<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    historyState, insertHistoryAction, resetHistory
} from '@app/store/historyStore.svelte.js';
import { createEventDispatcher } from 'svelte';
import * as m from "@app/paraglide/messages.js";
const dispatch = createEventDispatcher();

function approveEvents(approval) {
    try {
        eventGroupState[projectState.selected].selected.forEach(selectedEventIndex => {
            eventGroupState[projectState.selected].events[selectedEventIndex].approved = approval;
        });

        insertHistoryAction({
            name: "approve events", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch(err){
        console.log(err);
        console.log(err.message);
    } finally {
        dispatch("done");
    }
}
</script>

<a id="btnApproveEvents"
   role="menuitem"
    aria-label={m.context_menu_approve_label()}
   class="dropdown-item" href="#!/" onclick={() => approveEvents(true)}>
    {m.context_menu_approve()}
</a>
<a id="btnFailEvents"
   role="menuitem"
    aria-label={m.context_menu_fail_label()}
   class="dropdown-item" href="#!/" onclick={() => approveEvents(false)}>
    {m.context_menu_fail()}
</a>